"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import API from "@ym-framework/api-utils";
let AutoOpenLoginConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.autoStart = false;
    this.changeAutoStart = _.debounce((data) => __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/autoOpenLogin`, {
        autoStart: data
      });
    }), 500);
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        const auto_open_login = yield API.get(`api://base.local/storages/preference/autoOpenLogin`);
        this.autoStart = auto_open_login.data.value.autoStart;
      } catch (e) {
        let auto_start = true;
        yield API.put(`api://base.local/storages/preference/autoOpenLogin`, {
          autoStart: auto_start
        });
        this.autoStart = auto_start;
      }
    });
  }
};
AutoOpenLoginConfig = __decorateClass([
  Component
], AutoOpenLoginConfig);
export {
  AutoOpenLoginConfig as default
};
